import { BandeirasCartaoAceitas } from '@/services/pagamentos/types/pagamento';

export const mapeamentoBandeiras: Record<string, BandeirasCartaoAceitas> = {
  visa: 'visa',
  mastercard: 'mastercard',
  'american-express': 'amex',
  elo: 'elo',
};
